import Vue from 'vue'

export default {
  storeMessage (message) {
    return Vue.http.post(window.API_URL + 'doctors/store_messages', {message: message})
  }
}



// WEBPACK FOOTER //
// ./src/api/chat_message.js